import 'css-chunksrc/client/pages/zonePage/projectsPage/projectCreationButton/styles.scss';export default {
  "projectCreationButton": "_projectCreationButton_1kldc_1",
  "icon": "_icon_1kldc_20",
  "iconBox": "_iconBox_1kldc_28"
};